import { Button, CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficeIncludeSettlementPayeeQuickInfo extends Layout {
    buttonDrilldown: Button;
    citystatePayee: CityState;
    panelCarrierInfo: Panel;
    panelQuickInfo: Panel;
    sourceAllPayees: DataSource;
    textboxDotNumber: Textbox;
    textboxDrsPayeepayMethod: Textbox;
    textboxDrsPayeetypeOf: Textbox;
    textboxIccNumber: Textbox;
    textboxId: Textbox;
    textboxIntrastateCode: Textbox;
    textboxOffPayeeofficePaymethod: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPhoneNumber: Textbox;
}
